import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ConfirmDialogModule, DialogModule, MessageService, ToastModule } from 'primeng';
import { CurrencyPipe, NgIf } from '@angular/common';
import { RequestChannelType } from '../../../enums/request-channel-type';
import { JobAcceptResult } from '../../../enums/job-accept-result';
import { Message } from '../../../classes/Message';
import {
  GoogleAnalyticsService,
  SupplierInboxJobsService,
  SupplierJobInteractionService,
} from '../../../services';
import { SupplierJobChannel } from '../../../enums/supplier-job-channel';

@Component({
  selector: 'job-grabbed',
  templateUrl: './job-grabbed.component.html',
  standalone: true,
  styleUrls: ['./job-grabbed.component.css'],
  imports: [ConfirmDialogModule, DialogModule, ToastModule, CurrencyPipe, NgIf],
})
export class JobGrabbedComponent implements OnInit, OnDestroy {
  @Input() jobId: number;
  @Input() supplierPrice: number;

  @Input() visible: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private messageService: MessageService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private supplierInboxJobsService: SupplierInboxJobsService,
    private supplierJobInteractionService: SupplierJobInteractionService,
  ) {}

  ngOnDestroy(): void {
    this.visibleChange.emit(false);
  }

  protected isLoading: boolean = false;

  protected readonly toastKey: string = 'jobGrabbed';
  protected readonly toastPosition: string = 'top-right';

  ngOnInit(): void {}

  @Output() jobScheduleNow = new EventEmitter();

  private googleAnalyticsEventCategory: string = 'supplier_jobs_inbox';
  @Input() googleAnalyticsEventLabel: string;
  @Input() supplierJobChannel: SupplierJobChannel;

  close() {
    console.log('close');
    this.visible = false;
    this.visibleChange.emit(false);
  }

  async acceptJob() {
    this.supplierJobInteractionService.logSingleJobInteraction('BuyJobAttempt', this.jobId);

    this.googleAnalyticsService.eventEmitter(
      'accept_job',
      this.googleAnalyticsEventCategory,
      'accept_job',
      this.googleAnalyticsEventLabel,
    );

    this.isLoading = true;

    let res = await this.supplierInboxJobsService.acceptJob({
      jobId: this.jobId,
      taskSupplierSchedules: null,
      requestChannel: RequestChannelType.WebPortal,
      supplierJobChannel: this.supplierJobChannel,
    });

    this.isLoading = false;

    if (res == JobAcceptResult.Success) {
      this.messageService.add({ ...Message.Success('Job accepted.'), key: this.toastKey });
      this.supplierJobInteractionService.logSingleJobInteraction('BuyJobSuccess', this.jobId);

      this.close();
      this.jobScheduleNow.emit();
    } else if (res == JobAcceptResult.PreviouslyAccepted) {
      this.messageService.add(Message.Error('This job has been already accepted'));
    } else if (res == JobAcceptResult.TaskTypeRequirementNotMet) {
      this.messageService.add(
        Message.Error("One or more orders in this Job no longer matches Supplier's capabilities."),
      );
    } else if (res == JobAcceptResult.JobCancelled) {
      this.messageService.add(Message.Error('This job has been cancelled'));
    }

    /*    if (taskSchedules.length == 1 && taskSchedules[0].updateDefaultTravelMode) {
      void this.supplierInboxJobsService.updateDefaultTaskCollectionTravelMode(
        taskSchedules[0].taskCollectionTravelMode,
      );
    }*/
  }
}
